import {IBackend} from "./backend";
import {logger} from "./logger";

export class Dependencies {
  private static _instance: Dependencies;
  public static backend: IBackend;

  constructor(backend?: IBackend) {
    if (Dependencies._instance) {
      return Dependencies._instance;
    }

    if (!backend) {
      logger.error("Use of dependencies without initializing first");
      return;
    }

    Dependencies.backend = backend;
    Dependencies._instance = this;
  }
}
